import type { NextPage } from 'next';
import { ComponentProps } from 'react';
import styled from 'styled-components';
import BlogPost, { BlogPostType } from '../modules/BlogPost';
import Footer from '../modules/Footer';
import PageBottomCTA from '../modules/PageBottomCTA';
import Navbar from './Navbar';
import PageMeta from './PageMeta';
import PopularPosts from './PopularPosts';
import type BlogIndexPage from '../../pages/blog';
import PageLinks from '../modules/PageLinks';

export type Props = {
  blogPostData: BlogPostType;
  blogPageData: Pick<ComponentProps<typeof BlogIndexPage>['blogPageArchive'], 'popularPosts' | 'bottomPageLinks'>;
  navbarData: ComponentProps<typeof Navbar>;
};

const BlogPostPageContainer = styled.div`
`;

const PopularPostContainer = styled.div`
  background: var(--theme-background);
`;

const BlogPostPage: NextPage<Props> = ({
  blogPostData,
  navbarData,
  blogPageData: { popularPosts, bottomPageLinks },
}: Props) => {
  const ogImgUrl = `${blogPostData.featureImage.url}?fm=png&w=1200&h=630&fit=fill`;

  // Remove current post if it's in the popular posts list and use just the first 3
  const filteredPopularPosts = popularPosts.filter(
    (post) => post.slug !== blogPostData.slug,
  ).slice(0, 3);

  return (
    <BlogPostPageContainer>
      <PageMeta
        {...blogPostData}
        imageUrl={ogImgUrl}
        slug={`/blog/${blogPostData.slug}`}
        type="article"
      >
        <meta property="article:published_time" content={blogPostData.date} />
        {blogPostData.author && <meta property="article:author" content={blogPostData.author.name} />}
      </PageMeta>
      <BlogPost {...blogPostData} navbarData={navbarData} navbarTheme="Bluescape Strong" returnText="Return to Blog overview" returnUrl="/blog" shareBaseLocation="/blog" />
      <PopularPostContainer className="theme-charcoal-bleach">
        <PopularPosts popularPosts={filteredPopularPosts} />
      </PopularPostContainer>
      {bottomPageLinks && <PageLinks {...bottomPageLinks} />}
      {blogPostData.bottomCtaModule && <PageBottomCTA {...blogPostData.bottomCtaModule} />}
      <Footer {...navbarData} />
    </BlogPostPageContainer>
  );
};

export default BlogPostPage;
